<template>
  <div>
    <router-view />
  </div>

</template>

<script>

export default {
  name: 'Administration',
  components: {

  },
  created () {
    // When this component is created, set active navigation to "administration"
    this.$store.commit('setNavType', 'administration');
  },
  beforeRouteLeave (to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    this.$store.commit('setNavType', 'main');
    // Used to set navigation type back to default
    // When navigation is properly set, allow leaving the route
    next();
  }
}
</script>
